import { Box, Card, CardActionArea, Typography, styled } from "@mui/material"

export const CardLine = styled(Card)(({ theme: { palette } }) => ({
  width: "100%",
  backgroundColor: palette.common.americanDiamond,
  borderRadius: "100px",
  border: "none",
  overflow: "visible", // For absolute labels to be visible
}))

export const CardLineAction = styled(CardActionArea)<{ size?: "large" | "medium" }>(
  ({ theme, size = "medium" }) => ({
    height: size === "large" ? "78px" : "59px",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    borderRadius: "100px",
    overflow: "visible", // For absolute labels to be visible
  }),
)

export const CardLineContentGrid = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasThirdColumn",
})<{ hasThirdColumn?: boolean }>(({ theme, hasThirdColumn = false }) => ({
  display: "grid",
  gridTemplateColumns: hasThirdColumn ? "4fr 5fr 2fr" : "4fr 5fr",
  gridGap: theme.spacing(2),
  width: "100%",
  alignItems: "center",
}))

export const SmallLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.light,
  fontSize: theme.typography.pxToRem(11),
}))
